import { render, staticRenderFns } from "./SuspectView.vue?vue&type=template&id=5d79c363&scoped=true&"
import script from "./SuspectView.vue?vue&type=script&lang=js&"
export * from "./SuspectView.vue?vue&type=script&lang=js&"
import style0 from "./SuspectView.vue?vue&type=style&index=0&id=5d79c363&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79c363",
  null
  
)

export default component.exports